import React from 'react';

import { config } from 'data';
import { useQuery } from 'hooks';
import { profileService, withdrawalService } from 'services';
import { SinglePage } from 'components/layout';

import View from './View';

const WithdrawalPage = () => {
  const withdrawalPageQuery = useQuery({
    queryKey: [config.WITHDRAWAL_QUERY_KEY, 'page'],
    queryFn: () => Promise.all([
      profileService.getBalance(),
      withdrawalService.getWithdrawal(),
    ]),
  });

  return (
    <SinglePage
      query={withdrawalPageQuery}
      render={([balance, withdrawal]) => <View balance={balance} withdrawal={withdrawal} />}
    />
  );
};

export default WithdrawalPage;
